import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@app/App';
import '@app/styles/globals.css';
import { AzureInsights } from '@shared/config/azure-insights';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Élément #root introuvable dans le document');
}

createRoot(container).render(
  <StrictMode>
    <AzureInsights />
    <App />
  </StrictMode>,
);
